import React from 'react';
import {
  createTheme,
  ThemeProvider,
} from '@material-ui/core/styles';

import HomePage from './pages/Home';
import defaultTheme from './theme';
import { SnackbarProvider } from 'notistack';

const mainTheme = createTheme(defaultTheme);

function App() {
  return (
    <ThemeProvider theme={mainTheme}>
      <SnackbarProvider maxSnack={1}>
        <HomePage />
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
